module.exports = __webpack_public_path__ + "img/9788952745200.0dde2318.jpg";